import React from 'react';
import cn from 'classnames';
import { Button } from 'swag-client-common/components/ui/button';
import AnimationWrapper from 'swag-client-common/components/animation-wrapper';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { redirectWithSavingScroll } from 'swag-client-common/utils/tricks';
import boxSectionImg from './box.jpg';
import classes from './box-section.scss';
export const BoxSection = () => {
  const title = /*#__PURE__*/React.createElement("h3", {
    className: classes.title
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.accent
  }, "Open up "), /*#__PURE__*/React.createElement("span", {
    className: classes.rest
  }, "to a new experience."));
  return /*#__PURE__*/React.createElement(AnimationWrapper, {
    offset: 200,
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(classes.mobileOnly, classes.content)
  }, title), /*#__PURE__*/React.createElement("div", {
    className: classes.imageWrapper
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.image,
    src: boxSectionImg,
    alt: "box-experience"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.desktopOnly
  }, title), /*#__PURE__*/React.createElement("p", {
    className: classes.text
  }, "Create, package and ship fully custom branded boxes. Show your employees and customers some love!"), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    dataButton: "Let's Go!",
    type: "secondary",
    className: classes.button,
    onClick: redirectWithSavingScroll(APP_ROUTES.IN_A_BOX)
  }, "Let\u2019s Go!"))));
};